import { processResponse, sendGetRequest } from './dataRequestUtils';

/**
 * Get all instances
 */
export function getDataProcessorJobs({ sorts = { name: 1 }, successCallback, errorCallback, finallyCallback } = {}) {
    return sendGetRequest({
        url: `dataProcessor/jobs`,
        data: { sorts },
        ...processResponse({
            successCallback,
            errorCallback,
            finallyCallback,
            errorMessage: 'An error occurred attempting to fetch data processor jobs.',
        }),
    });
}
/**
 *
 */
export function getDataProcessorJob({ dataProcessorJobId }) {
    return sendGetRequest({
        url: `dataProcessor/job/${dataProcessorJobId}`,
    });
}
